import React, { useRef, useState } from 'react';
import styles from './Contact.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import useTabTitle from '../Hooks/useTabTitle';

const validationRules = {
    name: {
        name: "Nume dvs.*",
        regex: /^[a-zA-ZĂÂÎȘȚăâîșț\s-]{1,100}$/,
        error: 'Numele poate conține doar litere, spații, cratime.',
    },
    phone: {
        name: "Număr telefon",
        regex: /^[0-9+\-\s]{0,20}$/,
        error: 'Numărul de telefon este invalid.',
    },
    email: {
        name: "Email*",
        regex: /^[^\s@]+@[^\s@]+\.[^\s@]{1,200}$/,
        error: 'Email invalid.',
    },
    company: {
        name: "Compania dvs.",
        regex: /^[a-zA-Z0-9ĂÂÎȘȚăâîșț\s\-',.&()]{0,100}$/,
        error: 'Numele companiei este invalid.',
    },
    subject: {
        name: "Subiect*",
        regex: /^[a-zA-Z0-9ĂÂÎȘȚăâîșț\s\-',.!?()]{1,150}$/,
        error: 'Subiectul conține caractere interzise sau are dimensiune invalidă.',
    },
    question: {
        name: "Întrebare dvs.*",
        regex: /^[a-zA-Z0-9ĂÂÎȘȚăâîșț\s\-'",!?():%/]{1,1500}$/,
        error: 'Întrebarea conține caractere interzise sau are dimensiune invalidă.',
    },
};


const Contact = () => {
    useTabTitle('Contact');

    const formRef = useRef(null);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        company: '',
        subject: '',
        question: '',
    });

    const validateField = (name, value) => {
        const rule = validationRules[name];
        if (!rule) return null;

        if (value.trim() === '' && rule.regex.source.includes('{1,')) {
            return `Câmpul este obligatoriu.`;
        }

        if (!rule.regex.test(value)) {
            return rule.error;
        }

        return null;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log("formData")
        console.log(formData)
        // Actualizează starea imediat
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleOnBlur = (e) => {
        const { name, value } = e.target;
        console.log("errors")
        console.log(errors)
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: validateField(name, value),
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const newErrors = Object.keys(formData).reduce((acc, field) => {
            const error = validateField(field, formData[field]);
            if (error) acc[field] = error;
            return acc;
        }, {});

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        console.log("Form data:", formData);

        formRef.current.reset();
        setFormData({
            name: '',
            phone: '',
            email: '',
            company: '',
            subject: '',
            question: '',
        });
        setErrors({});
    };

    return (
        <div className={styles.contactPage}>
            <h1>Contactați-ne</h1>
            <p>Contactați-ne în legătură cu compania sau serviciile noastre. </p>
            <p>Vom face tot posibilul să răspundem cât mai repede.</p>
            <div className={styles.locations}>
                <div className={styles.location}>
                    <h2>București</h2>
                    <a href="tel:+40748556699" className={styles.phone}><FontAwesomeIcon icon={faPhone} /> +40 748 55 66 99</a>
                    <div className={styles.address}>
                        <a target="_blank" href="https://www.google.com/maps/place/Altep+România/@44.4267161,25.9978653,17z/data=!3m1!4b1!4m6!3m5!1s0x40b20167a836c69f:0x7f3f2adf99b88266!8m2!3d44.4267161!4d26.0004402!16s%2Fg%2F11j22x57c1?entry=ttu&g_ep=EgoyMDI0MTIwNC4wIKXMDSoASAFQAw%3D%3D"
                            className={styles.mapsLink}>
                            <i className="fa-solid fa-location-dot" />
                            <span>Str. Valea Cascadelor 21, Militari</span>
                        </a>
                    </div>
                </div>
                <div className={styles.location}>
                    <h2>Galați</h2>
                    <a href="tel:+40757994455" className={`${styles.phone} ${styles.bottom}`}><FontAwesomeIcon icon={faPhone} /> +40 757 99 44 55</a>
                </div>
            </div>
            <form ref={formRef} className={styles.contactForm} onSubmit={handleSubmit}>
                {Object.keys(validationRules).map((field) => (
                    <div key={field} className={styles.formGroup}>
                        <label htmlFor={field}>{validationRules[field].name}</label>
                        <div className={styles.inputContainer}>
                            {errors[field] && <p className={styles.errorText}>{errors[field]}</p>}
                            {field === 'question' ? (
                                <textarea
                                    className={`${styles.input} ${errors[field] && styles.errorInput}`}
                                    id={field}
                                    name={field}
                                    value={formData[field]}
                                    onChange={handleInputChange}
                                    onBlur={handleOnBlur}
                                    required
                                />
                            ) : (
                                <input
                                    className={`${styles.input} ${errors[field] && styles.errorInput}`}
                                    id={field}
                                    name={field}
                                    value={formData[field]}
                                    onChange={handleInputChange}
                                    onBlur={handleOnBlur}
                                    type={field === 'email' ? 'email' : 'text'}
                                    required={field !== 'phone' && field !== 'company'}
                                />
                            )}
                        </div>
                    </div>
                ))}
                <button type="submit" className={styles.submitButton}>Trimite</button>
            </form>
        </div >
    );
};

export default Contact;
